import { createSlice } from "@reduxjs/toolkit";
import { getFromServerTopic } from "../utility/slice";

const SLICE = "complianceVault";

export const getAllActiveComplianceFiles = getFromServerTopic({
  topic: SLICE,
  action: "findAllActiveComplianceFiles",
  contextOptionsFn: async ({ payload }) => payload,
  payloadFn: async (payload) => {
    return payload;
  },
});

export const uploadNewComplianceFiles = getFromServerTopic({
  topic: SLICE,
  action: "uploadNewFiles",
  payloadFn: async (payload) => {
    return payload;
  },
});

export const deleteFile = getFromServerTopic({
  topic: SLICE,
  action: "deleteFile",
  contextOptionsFn: async ({ payload }) => payload,
  payloadFn: async (payload) => {
    return payload;
  },
});

export const fetchFile = getFromServerTopic({
  topic: SLICE,
  action: "fetchFile",
  contextOptionsFn: async ({ payload }) => payload,
  payloadFn: async (payload) => {
    return payload;
  },
});

export const slice = createSlice({
  name: SLICE,
  initialState: {
    buildingFiles: {},
  },
  reducer: {},
  extraReducers: (builder) => {
    builder.addCase(getAllActiveComplianceFiles.fulfilled, (state, action) => {
      if (action.payload) {
        state.buildingFiles[`${action.meta.arg.site_id}`] = [
          ...action.payload.response,
        ];
      }
    });
  },
});

export default slice.reducer;
